export enum PortexHeadersEnum {
  TempToken = "x-portex-temp-token",
  ApiVersion = "x-portex-api-version",
  ClientName = "x-portex-client-name",
  ClientVersion = "x-portex-client-version",
  BrokerToken = "x-portex-broker-token",
}

export type PortexHeaders = `${PortexHeadersEnum}`;
